// extracted by mini-css-extract-plugin
export default {"bouncingLoader":"index_bouncingLoader__N-rPb"};